import moment from 'moment';
import * as React from 'react';
type Props = {
  start: string;
  end: string;
};
export default (props: Props) => {
  const { start, end } = props;
  const startDate = moment(start);
  const endDate = end ? moment(end) : null;
  if (endDate == null) {
    return startDate.format('MMMM D YYYY');
  }
  if (startDate.month() === endDate.month()) {
    return `${startDate.format('MMMM D')}—${endDate.format('D')}, ${endDate.format('YYYY')}`;
  }
  if (startDate.year() === endDate.year()) {
    return `${startDate.format('MMMM D')}—${endDate.format('MMMM D')}, ${endDate.format('YYYY')}`;
  }
  return (
    <>
      {startDate.format('MMMM DD YYYY')}—{endDate.format('MMMM DD YYYY')}`
    </>
  );
};
